import { BASE_URLS_PER_LOCALE } from '@packages/locale/constants/locales.ts'

const getAgentCookieDomain = (): string | undefined => {
  const { market, VERCEL_ENV } = useRuntimeConfig().public
  if (!market || VERCEL_ENV !== 'production') {
    return
  }

  const baseUrl = BASE_URLS_PER_LOCALE[market]
  if (!baseUrl) {
    return
  }

  return baseUrl.slice(baseUrl.indexOf('.'))
}

export {
  getAgentCookieDomain,
}